<section class="products">
  <header class="products__header">
    <h1 class="products__title">Productos</h1>
    <button class="products__add" type="button" (click)="onAdd()">Añadir producto</button>
  </header>

  <label class="products__search">
    <span>Buscar producto por nombre</span>
    <input #productSearch type="search" placeholder="Escribe el nombre del producto" [value]="searchTerm()"
      (input)="onSearch(productSearch.value)" />
  </label>

  @if (hasLoadError()) {
    <div class="products__message" role="alert">
      <p>No pudimos cargar los productos.</p>
      <button class="products__retry" type="button" (click)="retryLoading()">Reintentar</button>
    </div>
  } @else {
    <div class="products__results" [attr.aria-busy]="isLoading()">
      @if (isLoading()) {
        <p class="products__message" role="status">Cargando productos...</p>
      } @else if (products().length === 0) {
        <p class="products__message" role="status">
          {{ searchTerm().trim() ? 'No encontramos productos con ese nombre.' : 'Todavía no hay productos.' }}
        </p>
      } @else {
        <table class="products__table" role="table" aria-label="Productos">
          <thead role="rowgroup">
            <tr role="row">
              <th scope="col">Foto</th>
              <th scope="col">Nombre</th>
              <th scope="col">Categoría</th>
              <th scope="col">Precio</th>
              <th scope="col">Envío</th>
              <th scope="col">Estado</th>
              <th scope="col">Acciones</th>
            </tr>
          </thead>
          <tbody role="rowgroup">
            @for (product of products(); track product.id) {
              <tr app-product-table-row role="row" [product]="product" (edit)="onEdit($event)"></tr>
            }
          </tbody>
        </table>
      }
    </div>
  }

  @if (!hasLoadError() && totalPages() > 1) {
    <nav class="products__pagination" aria-label="Páginas de productos">
      <button type="button" [disabled]="isLoading() || currentPage() === 1" (click)="onPageChange(currentPage() - 1)">Anterior</button>
      <span aria-live="polite">Página {{ currentPage() }} de {{ totalPages() }}</span>
      <button type="button" [disabled]="isLoading() || currentPage() === totalPages()" (click)="onPageChange(currentPage() + 1)">Siguiente</button>
    </nav>
  }

  <app-storage-usage-bar />
</section>
